<template>
  <form data-cy="login-form" v-on:submit.prevent="login">
    <label class="for-reader">Email:</label>
    <input
        class="input-text-1 mb-3"
        data-cy="email-input"
        placeholder="email"
        type="text"
        v-model="user.email"
    />
    <input
        class="input-text-1 mb-3"
        data-cy="password-input"
        placeholder="password"
        type="password"
        v-model="user.password"
    />
    <input
        class="button-1"
        data-cy="login-button"
        type="submit"
        value="Login"
    />
  </form>
</template>

<script>
import { API_URL } from "../env.js";

export default {
  data() {
    return {
      user: {}
    };
  },
  props: {
      afterLogin: {
        type: Function,
        default: () => {},
      }
  },
  methods: {
    async login() {
      this.$loading(true);
      try {
        const res = await this.$store.dispatch("LOGIN_USER", this.user);
        this.afterLogin();
      } catch (e) {
        console.log("error");
        let errorMessage = "Your username or password may be wrong. Please try again.";
        this.$store.dispatch("populateErrors", errorMessage);
        // this.flashMessage.error({message: errorMessage});
      }
      this.$loading(false);
    }
  }
};
</script>
